import { StyledOrderReview, StyledOrderReviewWrapper } from './style';
import { FarmProduct } from 'public/context/CartContext';
import GroupedFarmCart from '../GroupedFarmCart/GroupedFarmCart';
import CartSummary from '../CartSummary/CartSummary';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Icon } from 'ui';
interface OrderReviewProps {
  farmProducts: FarmProduct[];
  isView?: boolean | undefined;
  priceTotal: number;
}

const OrderReview = ({
  farmProducts,
  isView,
  priceTotal,
}: OrderReviewProps) => {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <StyledOrderReviewWrapper>
      <StyledOrderReview>
        <div
          className="back-button"
          onClick={() => navigate('/products/all')}
        >
          <Icon name={'arrow-left'} type={'any'} />
          <span>{intl.formatMessage({ id: 'general.back_to_catalog' })}</span>
        </div>
        <div className='order-received-title'>{intl.formatMessage({ id: 'cart.your_order_received_title' })}</div>
        <CartSummary
          priceTotal={priceTotal}
          farmProducts={farmProducts}
          isView={isView}
        />
        <div className='grouped-farm-cart-wrap'>
          <GroupedFarmCart farmProducts={farmProducts} isView={isView} />
        </div>
      </StyledOrderReview>
    </StyledOrderReviewWrapper>
  );
};

export default OrderReview;
